import React, { useEffect, useState } from "react";
import { loadPackageActivate, loadPackagesResource, plansActivate, plansResource } from "../../helpers/configRoutes/backend_helper";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";
import CustomButtonOval from "../../components/form/CustomButtonOval";
import FiltersPagination from "../../components/elements/FiltersPagination";
import { currencyUSD } from "../../helpers/forms/formater";
import AddUpdLoadPackage from "./AddUpdLoadPackage";
import { useNavigate } from "react-router-dom";

const serviceIcons = {
    chatbot: 'fas fa-comments',
    'job creation from files': 'fas fa-file-import',
    'load creation from files': 'fas fa-file-import',
    'truck service prediction': 'fas fa-truck',
};

const getServiceIcon = (serviceName = '') => {
    const key = serviceName.toLowerCase();
    return serviceIcons[key] || 'fas fa-bolt';
};

const getPlanServices = (plan) => {
    if (Array.isArray(plan.services) && plan.services.length > 0) {
        return plan.services.map((item) => ({
            id: item.id,
            name: item.service?.name || 'AI Service',
            description: item.service?.description,
            active: Boolean(item.service?.is_active),
            limit: item.limit_max,
        }));
    }

    return [
        plan.ai_chatbot && {
            id: 'ai_chatbot',
            name: 'Chatbot',
            active: true,
            limit: plan.ai_chatbot_requests,
        },
        plan.ai_load_creation && {
            id: 'ai_load_creation',
            name: 'Job creation from files',
            active: true,
            limit: plan.ai_load_creation_requests,
        },
        plan.ai_truck_prediction && {
            id: 'ai_truck_prediction',
            name: 'Truck service prediction',
            active: true,
            limit: plan.ai_truck_prediction_requests,
        },
    ].filter(Boolean);
};

const formatPlanLimit = (value) => (value === null || value === '' || value === undefined ? 'Unlimited' : value);

const Suscription = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('subscriptions'); // 'subscriptions' | 'loads'

    /* ---------- Subscriptions (existente) ---------- */
    const [modalConfirm, setModalConfirm] = useState({
        show: false,
        title: 'Delete Subscriptions',
        loadig: false,
        textLoad: 'Processing',
        user: true
    });
    const [filters, setFilters] = useState({ perPage: 3, page: 1, search: '' });
    const [meta, setMeta] = useState({ total: 0, current_page: 0 });
    const [plans, setPlans] = useState([]);

    /* ---------- Load Packages (nuevo – placeholder) ---------- */
    const [loadFilters, setLoadFilters] = useState({ perPage: 3, page: 1, search: '' });
    const [loadMeta, setLoadMeta] = useState({ total: 0, current_page: 0 });
    const [loadPackages, setLoadPackages] = useState([]);
    const [loadPackage, setLoadPackage] = useState({ id: null });
    const [loadModal, setLoadModal] = useState({ show: false });

    useEffect(() => {
        const getPlans = async () => {
            const response = await plansResource('get', { params: filters });
            setPlans(response.plans);
            setMeta(response.meta);
        };
        getPlans();
    }, [filters]);

    useEffect(() => {
        const getPackages = async () => {
            const response = await loadPackagesResource('get', { params: loadFilters });
            setLoadPackages(response.packages);
            setLoadMeta(response.meta);
        };
        getPackages();
    }, [loadFilters]);

    const deletePlan = async () => {
        setModalConfirm({ ...modalConfirm, loading: true });
        const response = await plansResource('del', {}, modalConfirm.id);
        if (response.status) setFilters({ ...filters });
        setModalConfirm({ ...modalConfirm, loading: false, show: false, id: null });
    };

    const activate = async (item) => {
        const response = await plansActivate(item);
        if (response.status) setFilters({ ...filters });
    };

    /* ---------- Handlers Load Packages (placeholders) ---------- */
    const openLoadModal = (pkg = {}) => {
        setLoadPackage(pkg);
        setLoadModal({
            ...loadModal,
            show: true,
            title: pkg.id ? "Edit Load Package" : "Add Load Package"
        });
    };

    const tabs = [
        { key: 'subscriptions', label: 'Subscription Plans', count: meta.total },
        { key: 'loads', label: 'Load Packages', count: loadMeta.total || loadPackages.length },
    ];


    const activatePackage = async(pkt) => {
        console.log('soksok');
        const response = await loadPackageActivate(pkt);
        if (response.status) setLoadFilters({ ...loadFilters });
    }

    return (
        <>
            <div className="min-h-screen bg-cs-bg px-8 py-6">

                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                    <div>
                        <h2 className="text-2xl font-semibold text-cs-dark">
                            Plans &amp; Packages
                        </h2>
                        <p className="text-sm text-cs-muted">
                            Manage subscription plans and load packages for your clients
                        </p>
                    </div>

                    {activeTab === 'subscriptions' ? (
                        <CustomButtonOval
                            onClick={() => navigate('/subscriptions-create')}
                            className="bg-cs-primary text-white"
                        >
                            + New Plan
                        </CustomButtonOval>
                    ) : (
                        <CustomButtonOval
                            onClick={() => openLoadModal({ id: null })}
                            className="bg-cs-primary text-white"
                        >
                            + New Package
                        </CustomButtonOval>
                    )}
                </div>

                {/* Tabs */}
                <div className="border-b border-cs-border mb-8">
                    <nav className="-mb-px flex gap-6">
                        {tabs.map(tab => {
                            const isActive = activeTab === tab.key;
                            return (
                                <button
                                    key={tab.key}
                                    onClick={() => setActiveTab(tab.key)}
                                    className={`
                                        pb-3 px-1 text-sm font-medium border-b-2 transition-colors
                                        ${isActive
                                            ? 'border-cs-primary text-cs-primary'
                                            : 'border-transparent text-cs-muted hover:text-cs-dark'}
                                    `}
                                >
                                    {tab.label}
                                    <span
                                        className={`
                                            ml-2 inline-flex items-center justify-center
                                            rounded-full px-2 py-0.5 text-xs
                                            ${isActive
                                                ? 'bg-cs-primary-soft text-cs-primary'
                                                : 'bg-cs-bg-alt text-cs-muted'}
                                        `}
                                    >
                                        {tab.count || 0}
                                    </span>
                                </button>
                            );
                        })}
                    </nav>
                </div>

                {/* ---------- SUBSCRIPTIONS TAB ---------- */}
                {activeTab === 'subscriptions' && (
                    <>
                        <div className="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-6">
                            {plans.map((plan) => {
                                const planServices = getPlanServices(plan);
                                const loadPackage = plan.loadPackage;
                                const taxesAmount = parseFloat(plan.price) === 0
                                    ? 0
                                    : (parseFloat(plan.price || 0) * parseFloat(plan.taxes || 0)) / 100;

                                return (
                                    <div
                                        key={plan.id}
                                        className="relative overflow-hidden rounded-2xl bg-cs-surface border border-cs-border shadow-sm hover:shadow-lg transition-all flex flex-col"
                                    >
                                        <div className={`h-1.5 ${plan.active ? 'bg-cs-success' : 'bg-cs-primary'}`} />

                                        <div className="p-6 flex flex-col flex-1">
                                            <div className="flex items-start justify-between gap-4">
                                                <div className="min-w-0">
                                                    <div className="flex items-center gap-2 mb-2">
                                                        <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium
                                                            ${plan.active
                                                                ? 'bg-cs-success/10 text-cs-success'
                                                                : 'bg-cs-bg-alt text-cs-muted'}
                                                        `}>
                                                            <span className={`mr-1.5 h-2 w-2 rounded-full ${plan.active ? 'bg-cs-success' : 'bg-cs-muted'}`} />
                                                            {plan.active ? 'Active plan' : 'Inactive plan'}
                                                        </span>
                                                        <span className="text-xs text-cs-muted">ID #{plan.id}</span>
                                                    </div>

                                                    <h3 className="text-xl font-semibold text-cs-dark leading-snug pr-4">
                                                        {plan.name}
                                                    </h3>
                                                </div>

                                                <div className="flex gap-2 shrink-0">
                                                    <button
                                                        onClick={() => navigate(`/subscriptions-create/${plan.id}`)}
                                                        className="h-9 w-9 rounded-lg flex items-center justify-center hover:bg-cs-bg-alt"
                                                        title="Edit plan"
                                                    >
                                                        <i className="fas fa-pen text-cs-muted text-sm" />
                                                    </button>
                                                    <button
                                                        onClick={() =>
                                                            setModalConfirm({ ...modalConfirm, show: true, id: plan.id })
                                                        }
                                                        disabled={!plan.can?.delete}
                                                        className={`h-9 w-9 rounded-lg flex items-center justify-center
                                                            ${plan.can?.delete ? 'hover:bg-cs-bg-alt' : 'opacity-40'}
                                                        `}
                                                        title="Delete plan"
                                                    >
                                                        <i className="fas fa-trash text-cs-danger text-sm" />
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="mt-6 grid grid-cols-1 md:grid-cols-[1fr_1.4fr] gap-5">
                                                <div className="rounded-xl bg-cs-primary-soft border border-cs-primary/20 p-4">
                                                    <p className="text-xs font-medium uppercase tracking-wide text-cs-primary-dark">
                                                        Monthly price
                                                    </p>
                                                    <div className="mt-2 flex items-baseline gap-1">
                                                        <span className="text-4xl font-bold text-cs-primary">
                                                            {currencyUSD(plan.price)}
                                                        </span>
                                                        <span className="text-sm text-cs-muted">/ month</span>
                                                    </div>
                                                    <div className="mt-3 text-xs text-cs-primary-dark">
                                                        Taxes: <span className="font-semibold">{currencyUSD(taxesAmount)}</span>
                                                        <span className="text-cs-muted"> ({plan.taxes || 0}%)</span>
                                                    </div>
                                                </div>

                                                <div className="grid grid-cols-2 gap-3">
                                                    <div className="rounded-xl border border-cs-border bg-cs-bg p-3">
                                                        <p className="text-xs text-cs-muted">Trucks</p>
                                                        <p className="mt-1 text-lg font-semibold text-cs-dark">{formatPlanLimit(plan.trucks)}</p>
                                                    </div>
                                                    <div className="rounded-xl border border-cs-border bg-cs-bg p-3">
                                                        <p className="text-xs text-cs-muted">Users</p>
                                                        <p className="mt-1 text-lg font-semibold text-cs-dark">{formatPlanLimit(plan.users)}</p>
                                                    </div>
                                                    <div className="rounded-xl border border-cs-border bg-cs-bg p-3">
                                                        <p className="text-xs text-cs-muted">Trial</p>
                                                        <p className="mt-1 text-lg font-semibold text-cs-dark">{plan.day_trial} days</p>
                                                    </div>
                                                    <div className="rounded-xl border border-cs-border bg-cs-bg p-3">
                                                        <p className="text-xs text-cs-muted">Period</p>
                                                        <p className="mt-1 text-lg font-semibold text-cs-dark">#{plan.period_id || '-'}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mt-5 rounded-xl border border-cs-border bg-cs-bg p-4">
                                                <div className="flex items-center justify-between gap-3 mb-3">
                                                    <div className="flex items-center gap-2">
                                                        <span className="h-8 w-8 rounded-lg bg-cs-primary-soft text-cs-primary-dark flex items-center justify-center">
                                                            <i className="fas fa-truck-loading text-sm" />
                                                        </span>
                                                        <div>
                                                            <p className="text-sm font-semibold text-cs-dark">Included load package</p>
                                                            <p className="text-xs text-cs-muted">Loads included in this subscription</p>
                                                        </div>
                                                    </div>
                                                    {loadPackage && (
                                                        <span className="rounded-full bg-cs-surface border border-cs-border px-2.5 py-1 text-xs text-cs-muted">
                                                            Package #{loadPackage.id}
                                                        </span>
                                                    )}
                                                </div>

                                                {loadPackage ? (
                                                    <div>
                                                        <p className="text-sm font-medium text-cs-dark">{loadPackage.name}</p>
                                                        <div className="mt-3 grid grid-cols-3 gap-2 text-xs">
                                                            <div className="rounded-lg bg-cs-surface border border-cs-border p-2">
                                                                <p className="text-cs-muted">Loads</p>
                                                                <p className="font-semibold text-cs-dark">{loadPackage.loads}</p>
                                                            </div>
                                                            <div className="rounded-lg bg-cs-surface border border-cs-border p-2">
                                                                <p className="text-cs-muted">Validity</p>
                                                                <p className="font-semibold text-cs-dark">{loadPackage.validity_days} days</p>
                                                            </div>
                                                            <div className="rounded-lg bg-cs-surface border border-cs-border p-2">
                                                                <p className="text-cs-muted">Value</p>
                                                                <p className="font-semibold text-cs-dark">{currencyUSD(loadPackage.price)}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <p className="text-sm text-cs-muted">No load package assigned to this plan.</p>
                                                )}
                                            </div>

                                            <div className="mt-5">
                                                <div className="flex items-center justify-between mb-3">
                                                    <h4 className="text-sm font-semibold text-cs-dark">AI services included</h4>
                                                    <span className="text-xs text-cs-muted">{planServices.length} services</span>
                                                </div>

                                                {planServices.length > 0 ? (
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                                        {planServices.map((service) => (
                                                            <div
                                                                key={service.id}
                                                                className={`rounded-xl border p-3
                                                                    ${service.active
                                                                        ? 'border-cs-primary/25 bg-cs-primary-soft'
                                                                        : 'border-cs-border bg-cs-bg-alt opacity-75'}
                                                                `}
                                                            >
                                                                <div className="flex items-start gap-3">
                                                                    <span className={`h-9 w-9 rounded-lg flex items-center justify-center shrink-0
                                                                        ${service.active
                                                                            ? 'bg-cs-primary text-white'
                                                                            : 'bg-cs-border text-cs-muted'}
                                                                    `}>
                                                                        <i className={`${getServiceIcon(service.name)} text-sm`} />
                                                                    </span>
                                                                    <div className="min-w-0">
                                                                        <p className="text-sm font-semibold text-cs-dark leading-snug">
                                                                            {service.name}
                                                                        </p>
                                                                        <p className="mt-1 text-xs text-cs-muted">
                                                                            Limit: <span className="font-semibold text-cs-dark">{service.limit || 0}</span> requests
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <div className="rounded-xl border border-dashed border-cs-border bg-cs-bg p-4 text-sm text-cs-muted">
                                                        This plan has no AI services configured.
                                                    </div>
                                                )}
                                            </div>

                                            <div className="mt-auto pt-6 flex flex-col gap-3">
                                                <CustomButtonOval
                                                    onClick={() => activate(plan)}
                                                    isDisabled={!plan?.can?.activate}
                                                    className={
                                                        plan.active
                                                            ? `bg-cs-success text-white ring-2 ring-cs-success/30`
                                                            : `bg-cs-surface border border-cs-primary text-cs-primary hover:bg-cs-primary-soft`
                                                    }
                                                >
                                                    {plan.active ? 'Active' : 'Activate'}
                                                </CustomButtonOval>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="mt-8">
                            <FiltersPagination
                                filters={filters}
                                setFilters={setFilters}
                                showFilters={false}
                                meta={meta}
                            />
                        </div>
                    </>
                )}

                {/* ---------- JOB PACKAGES TAB ---------- */}
                {activeTab === 'loads' && (
                    <>
                        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                            {loadPackages.map((pkg) => (
                                <div
                                    key={pkg.id}
                                    className="relative rounded-xl bg-cs-surface border border-cs-border shadow-sm hover:shadow-md transition-shadow p-6"
                                >
                                    <div className="absolute top-4 right-4 flex gap-2">
                                        <button
                                            onClick={() => openLoadModal(pkg)}
                                            className="h-8 w-8 rounded-md flex items-center justify-center hover:bg-cs-bg-alt"
                                        >
                                            <i className="fas fa-pen text-cs-muted text-sm" />
                                        </button>
                                        <button
                                            disabled={!pkg.can?.delete}
                                            className={`h-8 w-8 rounded-md flex items-center justify-center
                                                ${pkg.can?.delete ? 'hover:bg-cs-bg-alt' : 'opacity-40'}
                                            `}
                                        >
                                            <i className="fas fa-trash text-cs-danger text-sm" />
                                        </button>
                                    </div>

                                    {/* Badge tipo */}
                                    <div className="mb-2">
                                        <span className="inline-flex items-center gap-1 rounded-full bg-cs-primary-soft text-cs-primary-dark text-xs font-medium px-2 py-0.5">
                                            <i className="fas fa-truck-loading" />
                                            Loads Pack
                                        </span>
                                    </div>

                                    <h3 className="text-lg font-semibold text-cs-dark">
                                        {pkg.name}
                                    </h3>

                                    <div className="mt-4">
                                        <span className="text-4xl font-bold text-cs-primary">
                                            ${pkg.price}
                                        </span>
                                        <span className="ml-1 text-sm text-cs-muted">one-time</span>
                                    </div>

                                    {/* Loads destacados */}
                                    <div className="mt-4 flex items-baseline gap-2">
                                        <span className="text-2xl font-bold text-cs-dark">{pkg.loads}</span>
                                        <span className="text-sm text-cs-muted">loads included</span>
                                    </div>

                                    <div className="mt-6 space-y-2 text-sm text-cs-dark">
                                        <div className="flex justify-between">
                                            <span>Taxes</span>
                                            <span>
                                                {currencyUSD(
                                                    parseFloat(pkg.price) === 0
                                                        ? 0
                                                        : (pkg.price * pkg.taxes) / 100
                                                )}
                                            </span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span>Validity</span>
                                            <span>{pkg.validity} days</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span>Price per load</span>
                                            <span>{currencyUSD(pkg.price / pkg.loads)}</span>
                                        </div>
                                    </div>

                                    <div className="mt-6 flex flex-col gap-3">
                                        <CustomButtonOval
                                            isDisabled={!pkg?.can?.activate}
                                            onClick={() => activatePackage(pkg)}
                                            className={
                                                pkg.active
                                                    ? `bg-cs-success text-white ring-2 ring-cs-success/30`
                                                    : `bg-cs-surface border border-cs-primary text-cs-primary hover:bg-cs-primary-soft`
                                            }
                                        >
                                            {pkg.active ? 'Active' : 'Activate'}
                                        </CustomButtonOval>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="mt-8">
                            <FiltersPagination
                                filters={loadFilters}
                                setFilters={setLoadFilters}
                                showFilters={false}
                                meta={loadMeta}
                            />
                        </div>
                    </>
                )}
            </div>


            <AddUpdLoadPackage
                packageItem={loadPackage}
                modal={loadModal}
                setModal={setLoadModal}
                filters={loadFilters}
                setFilters={setLoadFilters}
            />

            <ConfirmDeleteModal
                modal={modalConfirm}
                setModal={setModalConfirm}
                action={deletePlan}
            />
        </>
    );
};

export default Suscription;